module.exports = __webpack_public_path__ + "img/caselist1.3f503e0d.jpg";